import React from 'react'

import { avatarColors } from 'features/profile/AvatarColorPicker'

import OverlappingItems from './overlappingItems/OverlappingItems'
import Avatar from './Avatar'

interface Props {
  userNames: string[]
}

const AvatarList = ({ userNames }: Props) => {
  return userNames.length > 0 ? (
    <OverlappingItems
      size="small"
      itemNames={userNames}
      items={userNames.map((user, key) => {
        const names = user
          .split(' ')
          .map((word) => word[0])
          .join('')

        if (!names || names?.length === 0) {
          return <React.Fragment key={key}></React.Fragment>
        }

        return (
          <Avatar
            key={key}
            firstName={names[0]}
            lastName={names[1]}
            fullName={user}
            color={avatarColors[key % avatarColors.length]}
            className="w-8 h-8 border-2 text-xs border-white"
            showTooltip
          />
        )
      })}
    />
  ) : null
}

export default AvatarList
